module.exports = __webpack_public_path__ + "img/WTS_logo_Oct-2012-bigger.5bfe2b6c.png";